import { ACTIONS } from '../../hooks/trackings/actions'

const chipStyle = 'background: #479bdc;border-radius: 0.5em;color: white;font-weight: bold;padding: 2px 0.5em;'

const handlers = ['init', ...ACTIONS].reduce((acc, handlerName) => {
	return {
		...acc,
		[handlerName]: (...args) => {
			console.log(
				`%cTracking%c %s%c ${args.map(() => '%o').join(' ')}`,
				chipStyle,
				'color: #479bdc;',
				handlerName,
				'',
				...args
			)
		},
	}
}, {})

export default handlers
